import React from 'react';
import cx from 'classnames';
import { Service } from '~/types/models';
import { PlanCard } from '~/types/models/plasmic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

export interface InclusionsPanelProps extends Pick<PlanCard, 'inclusions'> {
  service?: Service;
  className?: string;
}

export function InclusionsPanel({
  inclusions,
  service,
  className,
}: InclusionsPanelProps) {
  return (
    <div className={cx(className, 'flex flex-col gap-y-2')}>
      {inclusions?.map((inclusion) => {
        return (
          <span
            key={inclusion.label}
            className='flex flex-row gap-x-3 items-center'
          >
            <FontAwesomeIcon
              icon={faCheck}
              className={cx('w-4 h-4', {
                'v2-text-blue-500': service === Service.VideoMessaging,
                'v2-text-magenta-500': service === Service.Testimonials,
              })}
            />
            <span className='v2-text-neutral-900 text-base'>
              {inclusion.label}
            </span>
          </span>
        );
      })}
    </div>
  );
}
